import { isValidDate } from '../../../../../utils/transformChartsAndTableData';

export const processColumns = (columns, config) => {
  if (!config || (typeof config === 'object' && Object.keys(config).length === 0)) return columns;

  return columns.map(col => {
    const fieldIdentifier = String(col.field);
    if (isValidDate(fieldIdentifier)) {
      const monthConfig = config?.month || {};
      const updatedCol = { ...col, ...monthConfig };

      if (monthConfig.threshold) {
        updatedCol.threshold = {
          ...monthConfig.threshold,
          field: fieldIdentifier
        };
      }
      if (monthConfig.templateConfig) {
        updatedCol.templateConfig = {
          ...monthConfig.templateConfig,
          keysToReplace: [fieldIdentifier, `${fieldIdentifier}_count`]
        };
      }

      return updatedCol;
    }

    const fieldConfig = config?.[fieldIdentifier];

    return fieldConfig ? { ...col, ...fieldConfig } : col;
  });
};
